(function($) {
    var searchTogglerBtn = $(".search-toggler");

    searchTogglerBtn.click(function () {
        $(this).toggleClass("search-toggler--opened");
        $(".search-form-wrapper").toggleClass("search-form-wrapper--opened");

        if(searchTogglerBtn.attr("aria-expanded") === "true") {
            searchTogglerBtn.attr("aria-expanded", "false")
        } else {
            searchTogglerBtn.attr("aria-expanded", "true")
        }
    });


// Barre de recherche avancée (publications)
    var advancedSearchToggler = $('.shop-header__toggle-advanced');

    if (advancedSearchToggler.length > 0) {
        advancedSearchToggler.on('click', function () {
            const $this = $(this);
            const advancedSearchWrapper = $('#advanced-search-wrapper');
            const wrapperEl = advancedSearchWrapper[0]; // DOM element

            $this.toggleClass('toggler--opened');
            advancedSearchWrapper.toggleClass('shop-header__advanced-search--opened');

            const isExpanded = $this.attr('aria-expanded') === 'true';

            if (isExpanded) {
                // Fermeture
                $this.attr('aria-expanded', 'false');
                advancedSearchWrapper.css('max-height', 0);
            } else {
                // Ouverture
                $this.attr('aria-expanded', 'true');
                advancedSearchWrapper.css(
                    'max-height',
                    wrapperEl.scrollHeight + 'px'
                );
            }
        });

        // Recalcul au resize
        let resizeTimeout;

        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                if (advancedSearchToggler.attr('aria-expanded') === 'true') {
                    advancedSearchWrapper.css(
                        'max-height',
                        advancedSearchWrapper[0].scrollHeight + 'px'
                    );
                }
            }, 150);
        });
    }
})(jQuery);

